import React, {useState,useEffect,useContext,useRef,lazy,Suspense} from 'react';
import { useTranslate } from 'react-redux-multilingual';
import { CardPerso,EditModalActionButton,DetailAbonnementCardModal,ViewDetailsBtn,ColumDataTableReorganize,AbonnementCardEditForm, SendCardActionButton, Loading, DownloadCardActionButton,useLocalStorage} from "@gull";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import cellEditFactory, { Type} from 'react-bootstrap-table2-editor';
import Moment from 'react-moment';
import { IsAuthContext } from 'app/App';
import { useCookies} from 'react-cookie';
import {scrollXDataTable} from 'app/scrollXDataTable';
import { Modal } from "react-bootstrap";
import axios from 'axios'
import swal from "sweetalert2";

const SendCardEmailForm = lazy(() => import('../form/SendCardEmailForm'));

const useLoad = (props) => {
    const t = useTranslate();
    const [allAbonnementCard, setAllAbonnementCard] = useState([]);
    const [postData,setPostData] = useState({});
    const [loading,setLoading]=useState(false)
    const [relance,setRelance]=useState(Date.now()) 
    const [sizeDatas,setSizeDatas]=useState(0)
    const [perPage,setPerPage]=useState(50)
    const [currentPage,setCurrentPage] = useState(1)

    useEffect(function () {
        if (props.clientId && (props.tabKey===undefined || props.tabKey=='abonnementcard'))
        (async function() {
            setLoading(true)
            const response = await axios.get(process.env.REACT_APP_API_URL+"api/pos/abonnement_card/get_all_of_client/"+props.clientId
            ).then((response) => {
                if(!response.data.valid){
                    let interms='';
                    var keys = Object.keys(response.data.errors);
                    for(var i = 0; i < keys.length; i++){
                        interms+=response.data.errors[keys[i]].join(',')+','
                    }
                    interms=interms.split(',')
                    let messageError='';
                    interms.forEach((interm)=>{
                        let finalMessage=interm.split('/!');
                        if(finalMessage.length==2){
                            messageError+=t(finalMessage[0],{name:finalMessage[1]})+'<br/>'
                        }
                        else{
                            messageError+=t(interm)+'<br/>'
                        }
                    })
                    messageError=messageError.replace('undefined','');
                    swal.fire(messageError, "", "error");
                }else{
                    setLoading(false)
                    setSizeDatas(response.data.count)
                    setAllAbonnementCard(response.data.datas)
                }
            }).catch((error) => {
                if(error=='end_session') return;
                let messageError = (error.response.status==403) ? t('forbiddenGeneral') : t('unknowError');
                swal.fire(messageError, "", "error");
            })
            setLoading(false)
        })()
    }, [relance,props.clientId,props.tabKey])

    return [loading,allAbonnementCard,setAllAbonnementCard,postData, setPostData,setRelance,sizeDatas,setSizeDatas,perPage,setPerPage,currentPage,setCurrentPage]
}

const CustomDataTable = (props) => {
    const t = useTranslate();
    
    useEffect(() => {
        scrollXDataTable(window.screen.width,props.columns.length)
    }, [window.screen.width,props.columns.length]);
    
    return (
        <BootstrapTable
            {...props.propst.baseProps}
            remote
            bootstrap4
            pagination={paginationFactory(props.paginationOptions)}
            noDataIndication={t('tableNoData')}
            onTableChange={ props.handleTableChange }
            defaultSortDirection={props.defaultSortDirection}
            rowStyle={ props.rowStyle }
            cellEdit={ cellEditFactory({ 
                mode: 'dbclick', 
                blurToSave: true,
            }) }
            hover
            condensed
            responsive
        />
    );
};

const SearchHistoriqueAbonnementCard = (props) =>{
    const t = useTranslate();
    const { authParam } = useContext(IsAuthContext)
    const [localStorage, setLocalStorage] = useLocalStorage(['abonnementcard_list_client_reorganize']);
    
    const [loading,allAbonnementCard,setAllAbonnementCard,postData, setPostData,setRelance,sizeDatas,setSizeDatas,perPage,setPerPage,currentPage,setCurrentPage]=useLoad(props)

    const [columnOrganize,setColumnOrganize]=useState([])
    const [showColumnOrganize,setShowColumnOrganize]=useState(false) 
    const [show,setShow]=useState(false) 
    const [detailAbonnementCard,setDetailAbonnementCard]=useState({}) 
    const [posid,setPosid]=useState(false) 

    const [abonnementCard,setAbonnementCard]=useState(false) // Bouton mail
    const [showMail,setShowMail]=useState(false) // Modal mail

    //Pour le cookie
    let current_date = new Date()
    let timestampdate = current_date.setDate(current_date.getDate() + 90)
    let expire_date = new Date(timestampdate)

    const module = props.module
    
    let abonnementCardList = new Array
    allAbonnementCard.map((value,ind) => {
        let obj ={
            id:value.id,
            customer: (value.client!=null) ? value.client.firstname+' '+value.client.name : '',
            masque:'',
            disponible:value.disponible,
            perte:value.perte,
            begin: (value.date_begin!=null) ? <Moment format="DD/MM/YYYY">{value.date_begin}</Moment> : '',
            end: (value.date_end!=null) ? <Moment format="DD/MM/YYYY">{value.date_end}</Moment> : '',
            status:value.status,
            reference:value.reference,
            section:(value.section) ? value.section.name : '',
            abonnement_article: value.abonnement_achat_article.abonnement_article?.map(article => article.name).join(' / '),
            abonnement_achat_article: value.abonnement_achat_article?.name,
            action: <span className="d-flex justify-content-between">
                        <ViewDetailsBtn setShow={setShow} paramShow='detailAbonnementCard' dataToShow={value} setDataToShow={setDetailAbonnementCard}/>
                        <SendCardActionButton abonnementCard={value.id} setAbonnementCard={setAbonnementCard} showMail={showMail} setShowMail={setShowMail}/>
                        <EditModalActionButton setShowEdit={setShow} paramShow={value}/> 
                        <DownloadCardActionButton id={value.id} token={value.token}/>
                    </span>,
            index: ind + 1,
        }
        abonnementCardList.push(obj)
    })

    const headerSortingStyle = { backgroundColor: '#c8e6c9' };

    let columns = [
        {
            dataField: "action",
            text: "Actions",
            editable: false,
            headerClasses: 'head-action-row',
            classes: 'body-action-row',
        },
        {
            dataField: "reference",
            text: t('referencePo'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "customer",
            text: t('administrationClientForm'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "disponible",
            text: t('availableCredit'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "perte",
            text: t('lostCredit'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "section",
            text: t('shop'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "begin",
            text: t('dateBeginAbonnement'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "end",
            text: t('dateEndAbonnement'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "abonnement_article",
            text: t('abonnement_article'),
            editable: false,
            headerSortingStyle,
        },
        {
            dataField: "abonnement_achat_article",
            text: t('abonnement_achat_article'),
            editable: false,
            headerSortingStyle,
        }
    ];

    const rowStyle = (row,rowIndex) => {
        const style = {};
        if(row.status==false){
            style.backgroundColor = '#fccfcf';//finalisé

        }
        return style;
    };  

    useEffect(function () {
        let columnCookie
        let arrCol = []
            
        if(localStorage.abonnementcard_list_client_reorganize){
            let newValueToIncludeInCookie
            let cookieLecture = localStorage.abonnementcard_list_client_reorganize.split(',')

            let already_done=[];
            cookieLecture.map(value=>{
                columns.map(item=>{
                    if(item.dataField==value){
                        arrCol.push(item)
                        already_done.push(value);
                    }
                })
            })
            columns.map(item=>{
                if(!already_done.includes(item.dataField)){ 
                    //si une nouvelle à été ajouté aux customsField, elle n'est pas ajoutée desuite au cookie de reorganisation si celui ci existe
                    //dans le cas où il n'existerait pas, on va créer un nouveau cookie afin de l'inclure pour ne pas avoir d'erreur sur les export 
                    newValueToIncludeInCookie=true
                    arrCol.push(item);
                }
            })

            columnCookie = arrCol
            if(newValueToIncludeInCookie==true){ 
                let arr = []
                arrCol.map(value=>
                    arr.push(value.dataField)
                )
                setLocalStorage('abonnementcard_list_client_reorganize',arr.join(),{ path: "/", expires: expire_date })
            }
        }else{
            columnCookie = columns
        } 
        setColumnOrganize(columnCookie)
    }, [])

    const sizePerPageOptionRenderer = ({
        text,
        page,
        onSizePerPageChange
    }) => (
        <li
            key={ text }
            role="presentation"
            className="dropdown-item"
            onMouseDown={ (e) => {
                e.preventDefault();
                onSizePerPageChange(page);
            } }
        >
            <a
                href="#"
                tabIndex="-1"
                role="menuitem"
                data-page={ page }
                style={ { color: 'black' } }
            >
                { text }
            </a>
        </li>
    );

    const handleTableChange = async (type, { page, sizePerPage }) => {
        setPerPage(sizePerPage)
        const response = await axios.post(process.env.REACT_APP_API_URL+"api/pos/gift_card/get_all/"+sizePerPage+"/"+page,postData
        ).then((response) => {
            setAllAbonnementCard(response.data.datas)
            setSizeDatas(response.data.count)
            setCurrentPage(page)
        }).catch((error) => {
            if(error=='end_session') return;
            swal.fire(t('unknowError'), "", "error");
        })
    }

    let paginationOptions = {
        page:currentPage,
        paginationSize: 5,
        pageStartIndex: 1,
        firstPageText: t('tableFirst'),
        prePageText: t('tableBack'),
        nextPageText: t('tableNext'),
        lastPageText: t('tableLast'),
        nextPageTitle: t('tableNextTitle'),
        prePageTitle: t('tableBackTitle'),
        firstPageTitle: t('tableFistTitle'),
        lastPageTitle: t('tableLastTitle'),
        sizePerPageOptionRenderer,
        sizePerPage: perPage,
        showTotal: true,
        totalSize: sizeDatas
    };

    const closeModal = () =>{
        setShow(false)
        setPosid(false)
    }

    const handleChange = (e) =>{
        if(e.target.value!=''){
            setPosid(e.target.value)
        }else{
            setPosid(false)
        }
    }
    
    const closeMailModal = () =>{
        setShowMail(false)
        setAbonnementCard(false)
    }

    return (<>
        <Modal size="lg" show={show} onHide={() => closeModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{(show=='detailAbonnementCard') ? t('detail')+' '+detailAbonnementCard.reference : (show=='createAbonnementCard') ? t('createAbonnementCard') : t('editAbonnementCard')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                {(show=='detailAbonnementCard') ? 
                    <DetailAbonnementCardModal 
                        detailAbonnementCards={detailAbonnementCard}
                        module={module}
                    />
                :
                    (!posid) ? 
                        <div className='form-group'>
                            <label>{t('selectSection')+' :'}</label>
                            <select className="form-control" value={posid} type="text" onChange={(e)=>handleChange(e)}>
                                <option value="">-- SELECT --</option>
                                {(authParam.sections.length!=0) && authParam.sections.map((value)=>{
                                    if(value.type!='ecommerce') return(<option key={value.id} value={value.id}>{value.name}</option>)
                                })}                                    
                            </select>
                        </div>
                    :
                        <AbonnementCardEditForm
                            posid={posid}
                            detailAbonnementCards={show}//pour l'édition, l'id de la carte abonnement est passé à show
                            setRelance={setRelance}
                            closeModal={closeModal}
                        />
                }
            </Modal.Body>
        </Modal>
        <Modal size="lg" show={showMail} onHide={() => closeMailModal()}>
            <Modal.Header closeButton>
                <Modal.Title>{t('sendDocEmail')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <Suspense fallback={<Loading></Loading>} >
                    <SendCardEmailForm  closeModal={closeMailModal} abonnementCard={abonnementCard}/>
                </Suspense>
            </Modal.Body>
        </Modal>
        <CardPerso header={t('abonnementcard')}>
            {(loading) ?
                <div className='d-flex justify-content-center'>
                    <div className="spinner-border spinner-border-sm"></div>
                </div>
            :
                columnOrganize.length!=0 &&
                    <small>
                        <ToolkitProvider
                            striped
                            keyField="index"
                            data={abonnementCardList}
                            columns={columnOrganize}
                            search
                        >
                        {(propst) => (
                            <>
                                <div className="d-flex justify-content-between">
                                    <div className='d-flex align-items-baseline'>
                                        <ColumDataTableReorganize 
                                            columnOrganize={columnOrganize}
                                            setColumnOrganize={setColumnOrganize}
                                            setCookie={setLocalStorage}
                                            cookieName='abonnementcard_list_client_reorganize'
                                            showColumnOrganize={showColumnOrganize}
                                            setShowColumnOrganize={setShowColumnOrganize}
                                            btnSwitch={false}//pour affiche ou non le btn swith
                                            initSwith={true}//initialier à false il affichera par défaut le toggle des colonnes, sur true il affichera le drag and drop pour changer la position des colonnes
                                        />&nbsp;&nbsp;&nbsp;
                                    </div>
                                </div>
                                <div className="position-relative">
                                    <CustomDataTable 
                                        propst={propst}
                                        paginationOptions={paginationOptions}
                                        columns={columns}
                                        handleTableChange={handleTableChange}
                                        defaultSortDirection="asc"
                                        rowStyle={ rowStyle }
                                    />
                                </div>
                            </>
                        )}
                        </ToolkitProvider>
                    </small>
            }
        </CardPerso>
    </>)
};

export default SearchHistoriqueAbonnementCard;